import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "34",
  height: "42",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#191B35",
  stroke: "#fff",
  "stroke-width": "2",
  d: "m18.153 40.617-.057.042c-.427.317-.94.38-1.352.321s-.885-.261-1.205-.682l-.003-.004L4.209 25.59l-.001-.001C2.165 22.946 1 19.759 1 16.382 1 7.854 8.239 1 17 1s16 6.854 16 15.382c0 3.376-1.165 6.564-3.208 9.207zm0 0 .051-.05.167-.167.048-.047.04-.052 11.332-14.71z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M9.96 13.731c.241-.5.467-1.015.768-1.588.166-.271.347-.514.678-.543h5.076c.332.029.512.271.678.543.302.573.528 1.088.768 1.588zm2.38 2.06h3.193c.196 0 .347.157.347.343 0 .172-.15.33-.347.33H12.34c-.18 0-.347-.158-.347-.33 0-.186.166-.343.347-.343m-.934-4.963c-.543 0-.874.186-1.326.786l-.753 1.616H8.182c-.18 0-.512.887.694.916l-.407.93c.015 1.187.015 2.36.015 3.533 0 .243.21.443.467.443h1.566c.257 0 .452-.2.452-.443v-.973h5.935v.973c0 .243.21.443.467.443h1.566c.257 0 .452-.2.452-.443 0-1.173.015-2.346.015-3.533l-.407-.93c1.22-.029.874-.916.708-.916h-1.144l-.753-1.616c-.452-.6-.784-.787-1.326-.787zm6.296 4.333c-.407 0-.753.315-.753.716 0 .386.346.714.753.714.421 0 .753-.328.753-.715 0-.4-.331-.715-.753-.715m-7.517 0c.407 0 .753.315.753.716 0 .386-.346.714-.753.714-.421 0-.753-.328-.753-.715 0-.4.332-.715.753-.715",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M11.656 9h4.569v1.371h-4.569zM22.415 12.034a.896.896 0 1 0 1.792 0 .896.896 0 0 0-1.792 0"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M20.909 13.207c-.473-.587-.57-1.776-.57-1.906a.44.44 0 0 1 .423-.472.44.44 0 0 1 .472.423c.033.424.163 1.14.375 1.402.196.244.684.505.929.505h1.483c.472 0 .716.293.863.538.147.243.929 1.889 1.075 2.215a.458.458 0 0 1-.407.651.46.46 0 0 1-.407-.26c-.245-.522-.506-1.092-.717-1.5l.081 1.565 1.255 4.268a.56.56 0 0 1-.375.685.5.5 0 0 1-.146.016.54.54 0 0 1-.522-.39l-1.075-3.667.081 3.486c0 .31-.228.554-.538.554a.535.535 0 0 1-.553-.538l-.098-4.285-.228-2.493c-.521-.064-1.125-.438-1.401-.797"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }